import React from 'react';
import RouteMap from './router/index.jsx'
class App extends React.Component{
  render() {
    return (
      <RouteMap/>
    );
  };
};

export default App;
